import * as React       from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import Stack            from "@mui/material/Stack";
import {
    DataGrid,
    GridActionsCellItem,
    GridColumns,
    GridRowParams
}                       from "@mui/x-data-grid"
import {
    useQuery, UseQueryResult
}                       from "react-query";
import {
    STUDENTS_TABLE_EMPTY,
    CLASSES_TABLE_NUM,
    TEACHERS_TABLE_NAME,
    TEACHERS_TABLE_EMAIL,
    TEACHER_TABLE_QR_CODE_TITLE,
}                           from 'config/config';
import {
    ReactComponent as QrCode
}                           from 'icons/qrCode.svg';
import { HttpClient }       from 'apiclient/ApiClient';
import IProfile             from 'models/IProfile';
import { useSession } from 'auth/AuthProvider';


export default function TeachersTable(
    props: {
        classId?: string,
        showQrCode: (profileId: string) => void
    }
) {
    const httpClient = HttpClient();
    const session = useSession();
    const resp: UseQueryResult<IProfile[]> = useQuery(
            `/school/classes/${props.classId}/members`,
            async () => await httpClient.get(`/school/classes/${props.classId}/members`)
        );
    let teachers: IProfile[] = [];
    if (resp.data) {
        teachers = resp.data.filter(prof => prof.profile_type === 'teacher');
    };
    const data_columns: GridColumns = [
        {   field: 'id',
            headerName: 'ID',
            editable: false,
            hide: true
        },
        {   field: 'num',
            headerName: CLASSES_TABLE_NUM,
            width: 56,
            editable: false,
            disableColumnMenu: true,
            hideSortIcons: true,
            align: 'center',
            headerAlign: 'center',
            cellClassName: 'NoPadding',
            headerClassName: 'NoPadding'
        },
        {   field: 'name',
            headerName: TEACHERS_TABLE_NAME,
            width: 220,
            editable: false,
            disableColumnMenu: true
        },
        {   field: 'email',
            headerName: TEACHERS_TABLE_EMAIL,
            flex: 1,
            minWidth: 160,
            editable: false,
            disableColumnMenu: true
        },
        {   field: 'actions',
            type: 'actions',
            flex: 0.25,
            minWidth: 60,
            align: 'right',
            cellClassName: 'ActionsCellRight',
            hideSortIcons: true,
            disableColumnMenu: true,
            getActions: (params: GridRowParams) => {
                // show QR code only signed teachers or for any teacher if user is manager
                if (session.role !== 'manager' && session.uid !== params.row.user_id) {
                    return [];
                }
                return([
                    <GridActionsCellItem
                        sx={{mx: 0}}
                        icon={<QrCode title={TEACHER_TABLE_QR_CODE_TITLE}/>}
                        onClick={() => {
                            props.showQrCode(params.row.id || '')
                        }}
                        label={TEACHER_TABLE_QR_CODE_TITLE}
                    />,
                ])
            } 
        }
    ];
    if (!resp.data) {
        return <CircularProgress sx={{alignSelf: 'center'}}/>
    } else {
        return(
            <DataGrid
                autoHeight
                sortingOrder={['desc', 'asc']}
                columns={data_columns}
                rows={(teachers.map((teacher, index) => ({
                    id: teacher.id,
                    user_id: teacher.user_id,
                    num: index + 1,
                    name: `${teacher.first_name || ''}${teacher.last_name ? ' ' + teacher.last_name : ''}`,
                    email: teacher.email?.includes("phantom@funexpected.org") ? "-" : teacher.email,
                }))) || []}
                hideFooter={true}
                rowHeight={56}
                headerHeight={56}
                components={{
                    NoRowsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            {STUDENTS_TABLE_EMPTY}
                        </Stack>
                    )
                }}
            />
        );
    }
};
